import { proCta } from '@/Shared/proPlanState'

/**
 * The top bar's Pro pill (86bcd9hg3, decision 24): what it says and what it does for
 * the signed-in landlord, or null when it should not show. `routeFn` is Ziggy's route().
 *
 * 86bc9e403: a Basic landlord's "Upgrade to Pro" now opens the combined checkout in place
 * (action: 'upgrade') instead of linking to /pricing — the layout mounts the pop-up and
 * fetches a SetupIntent on demand. Switching and fixing a card still just link out.
 */
export function proUpgradeNav(user, routeFn) {
    if (!user || user.role !== 'agent') {
        return null
    }

    switch (proCta(user.pro_plan)) {
        case 'upgrade':
            return { label: 'Upgrade to Pro', action: 'upgrade' }
        case 'switch':
            return { label: 'Upgrade to Pro', href: `${routeFn('payment-methods.index')}#switch-plan` }
        case 'fix-card':
            return { label: 'Update card', href: routeFn('payment-methods.index') }
        default:
            return null
    }
}
